/**
 * GADDAR BİLGİ - CS Sunucu Durumu Widgetı
 */

export const CsServerWidget = {
    init: async function () {
        // Poll until at least one dynamic container is available
        const waitForElement = () => new Promise((resolve) => {
            const check = () => {
                const els = document.querySelectorAll('.cs-servers-dynamic-container');
                if (els.length > 0) return resolve(els);
                setTimeout(check, 500);
            };
            check();
        });

        await waitForElement();
        console.log('[CS-Widget] Containers found, starting refresh...');
        this.refresh();

        // Refresh every 20 seconds
        if (this._interval) clearInterval(this._interval);
        this._interval = setInterval(() => this.refresh(), 20000);
    },

    refresh: async function () {
        const containers = document.querySelectorAll('.cs-servers-dynamic-container');
        if (containers.length === 0) return;

        console.log('[CS-Widget] Refreshing status...');
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000); // 10s timeout

        try {
            const baseUrl = (window.multiplayer && window.multiplayer.HTTP_URL)
                ? `${window.multiplayer.HTTP_URL}/api/cs-status`
                : '/api/cs-status';

            // Add cache buster and explicit headers to ensure real-time data
            const apiUrl = `${baseUrl}?t=${Date.now()}`;

            const response = await fetch(apiUrl, {
                signal: controller.signal,
                headers: {
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            });
            clearTimeout(timeoutId);

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const servers = await response.json();
            this._lastUpdate = new Date().toLocaleTimeString();
            this.render(servers);
        } catch (e) {
            clearTimeout(timeoutId);
            console.error('[CS-Widget] Refresh Error:', e);
            containers.forEach(list => {
                list.innerHTML = `<div style="text-align:center; color:rgba(255,255,255,0.4); font-size:0.7rem; padding:10px;">Sunucu bilgisi şu an alınamıyor.</div>`;
            });
        }
    },

    render: function (servers) {
        const containers = document.querySelectorAll('.cs-servers-dynamic-container');
        if (containers.length === 0) return;

        const html = servers.map(server => {
            const isOnline = server.status === 'online';
            const playerPercent = isOnline ? Math.min(100, Math.round((server.players / server.maxPlayers) * 100)) : 0;
            const progressColor = isOnline ? (server.players / server.maxPlayers > 0.8 ? '#ff4d4d' : '#2ecc71') : '#555';

            // Port based icon and name mapping
            let displayName = server.name || 'CS Sunucusu';
            let iconFile = 'csico.png';

            if (server.port === 27016 || server.name.includes('1.6')) {
                displayName = 'Counter-Strike 1.6 Server';
                iconFile = 'cs1.png';
            } else if (server.port === 27015 || server.name.includes('Source')) {
                displayName = 'Counter-Strike Source Server';
                iconFile = 'cs2.png';
            }

            const iconUrl = new URL(`../../assets/images/${iconFile}`, import.meta.url).href;

            const lastUpdateHtml = this._lastUpdate ? `
                <div class="cs-last-update">
                    <span class="cs-pulse-dot"></span>
                    Son Güncelleme: ${this._lastUpdate}
                </div>
            ` : '';

            return `
                <div class="cs-server-row">
                    <!-- TOP SECTION: Logo, Map and Player Info -->
                    <div class="cs-server-header">
                        <!-- Larger, sleek logo -->
                        <img src="${iconUrl}" class="cs-icon" alt="CS">
                        
                        <div class="cs-info-stack">
                            <!-- Info row: Map and Player counter -->
                            <div class="cs-status-line">
                                <div class="cs-map-info">
                                    <span style="opacity: 0.7;">📍</span> ${server.map || '---'}
                                </div>
                                <div class="cs-player-count">
                                    <span>${isOnline ? server.players : '0'}</span> / ${isOnline ? server.maxPlayers : '0'}
                                </div>
                            </div>
                            
                            <!-- Sleek Progress Bar -->
                            <div class="cs-progress-bg">
                                <div class="cs-progress-fill" style="width: ${playerPercent}%; background: ${progressColor}; box-shadow: 0 0 10px ${progressColor}44;"></div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- BOTTOM SECTION: Title and Action Button -->
                    <div class="cs-server-footer">
                        <div class="cs-name">${displayName}</div>
                        <button class="cs-action-btn" onclick="window.open('steam://connect/${server.ip}:${server.port}')">
                            Hemen Oyna
                        </button>
                    </div>
                    ${lastUpdateHtml}
                </div>
            `;
        }).join('');

        containers.forEach(list => {
            list.innerHTML = html;
        });
    }
};

// Expose to window so main.js can call window.CsServerWidget.init()
window.CsServerWidget = CsServerWidget;
